import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector, useDispatch } from 'react-redux';
import NotifyModal from 'components/NotifyModal';
import { DIALOG_KINDS } from 'constants/dialogKinds';
import { useSnackbar } from 'hooks';
import { HuntGroupService } from 'services';
import { actionTypes } from 'containers/pages/Teams/redux';

const onGoToCallFlow = () => {
  window.location.href = `${window.location.origin}/apps/voice-admin/#/voice/call-flows`;
};

const DeleteVoiceModal = () => {
  const {
    deleteVoiceModal: { canBeDeleted, open, team },
  } = useSelector((state) => state.teamsReduxReducer);
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const setSnackbar = useSnackbar();

  const closeModal = () => {
    dispatch({
      type: actionTypes.SET_DELETE_VOICE_MODAL,
      payload: { open: false },
    });
  };

  const onDelete = async () => {
    setIsLoading(true);
    try {
      await HuntGroupService.deleteHuntGroups({
        huntGroupId: team.durableCallGroupId,
        teamId: team.id,
      });
      dispatch({
        type: actionTypes.DELETE_TEAM_VOICE,
        payload: team.id,
      });
      queryClient.invalidateQueries(['getTeams']);
    } catch {
      setSnackbar({
        message: `We were unable to delete voice for team ${team.name}. Please try again later or contact support if the issue persists.`,
        severity: 'error',
      });
    } finally {
      closeModal();
      setIsLoading(false);
    }
  };

  return (
    <NotifyModal
      confirmText={canBeDeleted ? 'Delete' : 'Go to call flows'}
      isLoading={isLoading}
      mode={canBeDeleted ? DIALOG_KINDS.ERROR : DIALOG_KINDS.INFO}
      onCancel={closeModal}
      onConfirm={canBeDeleted ? onDelete : onGoToCallFlow}
      open={open}
      title={
        canBeDeleted
          ? `Delete Voice for ${team.name}`
          : `${team.name} cannot have voice deleted`
      }
    >
      <div
        className="m-notify-modal"
        data-testid="PlatformAdminUI-Teams-DeleteVoiceModal-Body"
      >
        {canBeDeleted ? (
          `This will delete the team's voice data and voice settings. This cannot be undone.`
        ) : (
          <>
            <p style={{ marginBottom: '21px' }}>
              {team.name} is being used in a call flow and cannot have voice
              settings deleted.
            </p>
            <p>
              To delete: remove team from any call flows where it is being used.
              Once complete you can return here.
            </p>
          </>
        )}
      </div>
    </NotifyModal>
  );
};

export default DeleteVoiceModal;
